
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nwbxjiorslohvrmvurzy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im53YnhqaW9yc2xvaHZybXZ1cnp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgyNjc4MTYsImV4cCI6MjA1Mzg0MzgxNn0.-l93OypS6rQkfqsNzLop_NiO8rD2TLJpQxxNZarOpVA";

const getRedirectTo = () => {
  if (typeof window === 'undefined') return 'http://localhost:8080';
  
  if (window.location.hostname === 'localhost') {
    return `${window.location.protocol}//${window.location.host}`;
  }
  
  return 'https://82e93cee-80a8-445e-8a72-56ca3501babd.lovableproject.com';
};

console.log('Initialisation du client Supabase...');

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'supabase-auth-token'
    }
  }
);

// Gérer les événements d'authentification
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Événement auth:', event);
  if (event === 'SIGNED_OUT') {
    console.log('Utilisateur déconnecté');
  } else if (event === 'SIGNED_IN') {
    console.log('Utilisateur connecté:', session?.user?.email);
  } else if (event === 'TOKEN_REFRESHED') {
    console.log('Token rafraîchi');
  }
});

console.log('Client Supabase initialisé avec succès');
